import { TransactionHistoryRequestModel } from "api/baseTransactionHistory/TransactionHistoryRequestModel";

export class MobiSimRegistrationRequestModel extends TransactionHistoryRequestModel {
  carrier?: Array<string>;
  code?: string;
  simType?: number;
  fromDate?: string;
  limit?: number;
  page?: number;
  pagination?: boolean;
  phoneNumber?: string;
  status?: number;
  toDate?: string;
  package?: string;
  type?: number;
  created?: Record<string, unknown>[];
  store?: Array<string>;
  staff?: Array<string>;
  isdnOrIccid?: string;
  isOnlyStore?: string;
  order?: string;

  constructor(data?: {
    carrier?: Array<string>;
    code?: string;
    simType?: number;
    fromDate?: string;
    limit?: number;
    page?: number;
    pagination?: boolean;
    phoneNumber?: string;
    status?: number;
    toDate?: string;
    package?: string;
    type?: number;
    isdnOrIccid?: string;
    created?: Record<string, unknown>[];
    store?: Array<string>;
    staff?: Array<string>;
    isOnlyStore?: string;
    order?: string;
  }) {
    super();
    this.status = data?.status;
    this.code = data?.code;
    this.carrier = data?.carrier;
    this.phoneNumber = data?.phoneNumber;
    this.page = data?.page;
    this.limit = data?.limit;
    this.isdnOrIccid = data?.isdnOrIccid;
    this.pagination = data?.pagination;
    this.fromDate = data?.fromDate;
    this.toDate = data?.toDate;
    this.package = data?.package;
    this.created = data?.created;
    this.simType = data?.simType;
    this.type = data?.type;
    this.store = data?.store;
    this.staff = data?.staff;
    this.order = data?.order;
    this.isOnlyStore = data?.isOnlyStore;
  }
}
